"use client";
import { useEffect } from "react";
import Link from "next/link";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  useEffect(() => {
    console.error("global_error", error);
  }, [error]);
  return (
    <div className="mx-auto max-w-xl px-6 py-32 text-center space-y-8">
      <h1 className="text-4xl font-semibold tracking-tight text-neutral-800">エラー</h1>
      <p className="text-sm text-neutral-600 leading-relaxed">
        予期しないエラーが発生しました。しばらくしてから再度お試しください。
      </p>
      <div className="flex justify-center gap-4">
        <button
          onClick={() => reset()}
          className="px-6 py-3 rounded-full bg-primary-600 text-white text-sm font-medium hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 transition"
        >
          再試行
        </button>
        <Link
          href="/"
          className="px-6 py-3 rounded-full border border-neutral-300 text-sm font-medium hover:border-primary-400 hover:text-primary-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 transition"
        >
          トップへ
        </Link>
      </div>
    </div>
  );
}
